/**
 * Canonical media-manager template types. The value is what lives in
 * `media_manager_templates.template_type` in the database — stable identifiers;
 * add new members, do not rename existing ones.
 */
export const TemplateType = {
  SCHEDULE: 'schedule',
  MULTIPLE_SCHEDULE: 'multiple_schedule',
  RESULTS: 'results',
  MULTIPLE_RESULTS: 'multiple_results',
  TOURNAMENT_TABLE: 'tournament_table',
  TOP_PLAYERS_BY_INDICATORS: 'top_players_by_indicators',
  PLAYOFF_BRACKET: 'playoff_bracket',
  BIRTHDAY: 'birthday',
  SYMBOLIC_TEAM_ROUND: 'symbolic_team_round',
  SYMBOLIC_TEAM_CHAMPIONSHIP: 'symbolic_team_championship',
  // Match video review (IMGM-1606): drawn in the browser over the clips, never rendered by the server.
  VIDEO_INTRO: 'video_intro',
  VIDEO_GOAL_PLATE: 'video_goal_plate',
  VIDEO_DANGER_PLATE: 'video_danger_plate',
} as const;

export type TemplateType = (typeof TemplateType)[keyof typeof TemplateType];

const KNOWN_TYPES: ReadonlySet<string> = new Set(Object.values(TemplateType));

export function isKnownTemplateType(value: string | undefined | null): value is TemplateType {
  return typeof value === 'string' && KNOWN_TYPES.has(value);
}

export const DEFAULT_TEMPLATE_TYPE: TemplateType = TemplateType.SCHEDULE;
